import React from 'react';
import type { CatalogueLayer } from './catalogueLayers';
import useCatalogueAttribution from './useCatalogueAttribution';

const LayerCredit = ({ layer }: { layer: CatalogueLayer }) => {
    const attribution = useCatalogueAttribution(layer.collectionId);

    if (!attribution) return null;

    const { creditedTo, credit, url, license } = attribution;
    const wording = credit ?? creditedTo;

    return (
        <div className='flex flex-col gap-1 text-xs'>
            {wording && (
                <span>
                    {url ? (
                        <a href={url} target='_blank' rel='noreferrer' className='underline'>
                            {wording}
                        </a>
                    ) : (
                        wording
                    )}
                </span>
            )}
            {/* The wording a licensor asks for states the licence itself. */}
            {!credit && <span>{license}</span>}
        </div>
    );
};

export default LayerCredit;
